document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.wcl-header__mobile');
    const openBtn = document.querySelector('.js-open-menu');
    const closeBtn = document.querySelector('.js-close-menu');

    const MENU_LINK_SELECTOR = '.wcl-mega-menu__col-list a';

    const isMobile = () => window.innerWidth <= 1024;

    const closeMenu = () => {
        if (!menu) return;

        menu.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
    };

    if (menu && openBtn && closeBtn) {
        openBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            menu.classList.add('is-open');
            document.body.classList.add('overflow-hidden');
        });

        closeBtn.addEventListener('click', () => {
            closeMenu();
        });

        document.addEventListener('click', (e) => {
            if (
                menu.classList.contains('is-open') &&
                !menu.contains(e.target) &&
                !openBtn.contains(e.target)
            ) {
                closeMenu();
            }
        });
    }

    document.addEventListener('click', (e) => {
        if (isMobile() && e.target.closest(MENU_LINK_SELECTOR)) {
            closeMenu();
        }
    }, true);
});